import { render, staticRenderFns } from "./CardProductFeatured.vue?vue&type=template&id=156e0e1e"
import script from "./CardProductFeatured.vue?vue&type=script&setup=true&lang=js"
export * from "./CardProductFeatured.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports